const DEFAULT_RETURN_HOSTS = 'localhost:4000,127.0.0.1:4000,finlit.teachtappy.ai';

export function allowedReturnHosts() {
  const rawHosts = process.env.REACT_APP_AUTH_RETURN_HOSTS || DEFAULT_RETURN_HOSTS;

  return rawHosts
    .split(',')
    .map((host) => host.trim())
    .filter(Boolean);
}

export function sanitizeReturnTo(raw, allowedHosts = allowedReturnHosts(), base = window.location.origin) {
  if (!raw) return null;

  try {
    const url = new URL(raw, base);
    const allowed = new Set(allowedHosts);

    if ((url.protocol === 'http:' || url.protocol === 'https:') && allowed.has(url.host)) {
      return url.toString();
    }
  } catch (error) {
    return null;
  }

  return null;
}
